import { render, staticRenderFns } from "./ContentItemsListAddNew.vue?vue&type=template&id=2a43d411&"
import script from "./ContentItemsListAddNew.vue?vue&type=script&lang=js&"
export * from "./ContentItemsListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ContentItemsListAddNew.vue?vue&type=style&index=0&id=2a43d411&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports